import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { OrganizationUserDeleteDialog } from '@/features/organization-users/components/organization-user-delete-dialog'
import { OrganizationUserPermissionsDialog } from '@/features/organization-users/components/organization-user-permissions-dialog'
import type { OrganizationUser } from '@/features/organization-users/types/organization-user'

type OrganizationUsersActionsCellProps = {
  organizationId: string
  selfUserId: string
  user: OrganizationUser
}

export function OrganizationUsersActionsCell({
  organizationId,
  selfUserId,
  user,
}: OrganizationUsersActionsCellProps) {
  const { t } = useTranslation('organizationUsers')
  const [permissionsOpen, setPermissionsOpen] = useState(false)
  const [deleteOpen, setDeleteOpen] = useState(false)

  return (
    <>
      <div className="flex flex-wrap items-center justify-end gap-2">
        {user.id !== selfUserId && (
          <Button
            type="button"
            variant="destructive"
            size="sm"
            onClick={() => {
              setDeleteOpen(true)
            }}
          >
            {t('actions.deleteUser')}
          </Button>
        )}
        <Button
          type="button"
          variant="secondary"
          size="sm"
          onClick={() => {
            setPermissionsOpen(true)
          }}
        >
          {t('actions.editPermissions')}
        </Button>
      </div>
      <OrganizationUserPermissionsDialog
        organizationId={organizationId}
        selfUserId={selfUserId}
        user={user}
        open={permissionsOpen}
        onOpenChange={setPermissionsOpen}
      />
      <OrganizationUserDeleteDialog
        organizationId={organizationId}
        user={user}
        open={deleteOpen}
        onOpenChange={setDeleteOpen}
      />
    </>
  )
}

type OrganizationUsersEmailCellProps = {
  user: OrganizationUser
}

export function OrganizationUsersEmailCell({ user }: OrganizationUsersEmailCellProps) {
  const { t } = useTranslation('organizationUsers')
  return (
    <div className="space-y-2">
      <div>{user.email}</div>
      {user.passwordResetRequired && (
        <Badge variant="secondary">
          {t('invitationStats.passwordResetRequired')}
        </Badge>
      )}
    </div>
  )
}
